var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeMinorDiscomfort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1923.86 1987.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d1c7bd;\n      }\n\n      .cls-2 {\n        fill: #ffd2c0;\n      }\n\n      .cls-3 {\n        fill: #e59076;\n      }\n\n      .cls-4 {\n        fill: #995222;\n      }\n\n      .cls-5 {\n        fill: #7c3108;\n      }\n\n      .cls-6 {\n        fill: #cbad8d;\n      }\n\n      .cls-7 {\n        fill: #8c3f0a;\n      }\n\n      .cls-8 {\n        fill: #a48374;\n      }\n\n      .cls-9 {\n        fill: #6d2e03;\n      }\n\n      .cls-10 {\n        fill: #f2ad97;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 961.93,
    cy: 993.76,
    rx: 961.93,
    ry: 993.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 961.93,
    cy: 993.76,
    rx: 824.65,
    ry: 851.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 961.93,
    cy: 993.76,
    rx: 636.22,
    ry: 657.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 564.06,
    cy: 1181.93,
    rx: 128.16,
    ry: 132.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 564.06,
    cy: 1181.93,
    rx: 73.64,
    ry: 76.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 1359.8,
    cy: 1181.93,
    rx: 128.16,
    ry: 132.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1359.8,
    cy: 1181.93,
    rx: 73.64,
    ry: 76.08
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 563.36,
    y: 591.51,
    width: 797.13,
    height: 995.63,
    rx: 41.76,
    ry: 41.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M817.41,467.64c.68,218.63-117.69,416.29-297.89,517.59-38.12,21.43-84.92-9.41-81.1-54.07,12.96-151.71,78.22-290.57,180.81-388.36,55.43-53.03,121.73-93.92,196.54-118.5,1.07,14.31,1.65,28.73,1.65,43.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1453.06,949.15c-334.11,178.19-754.15-25.2-833.83-406.37,55.12-52.74,120.98-93.47,195.28-118.08,310.62-104.17,620.16,140.04,667.33,466.42,3.41,23.59-8.26,47.08-28.77,58.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1192.79,977.17h0c-57.62,0-114.71-9.22-169.54-27.48-53.39-17.7-103.8-43.6-149.7-76.86-45.72-33.17-86.13-72.95-119.95-118.32-34.54-46.21-61.59-97.17-80.34-151.67-1.63-4.66-1.36-9.69.63-14.16,2.08-4.47,5.68-7.92,10.29-9.6,9.11-3.35,19.74,1.87,22.99,11.27,72.14,209.06,267.29,349.55,485.44,349.55h.18c20.29,0,40.58-1.3,60.33-3.73h0c9.83-1.21,18.93,6.15,20.11,16.21.55,4.94-.72,9.87-3.7,13.79-2.97,3.91-7.3,6.43-12.08,6.99-21.19,2.7-43.01,4-64.66,4ZM1326.08,959.19c-8.12,0-15.33-5.69-17.4-13.79-2.62-9.97,3.15-20.22,12.71-22.92h.1c1.44-.37,3.06-.56,4.6-.56,8.12,0,15.33,5.59,17.4,13.79,2.62,9.88-3.06,20.03-12.62,22.73,0,.09-.1.09-.1.09-1.53.37-3.15.66-4.69.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1481.83,891.13c-47.17-326.39-356.71-570.6-667.33-466.42-74.3,24.62-140.16,65.35-195.28,118.08,1.48,7.06,3.11,14.04,4.81,20.98,31.36-18.64,64.83-34.16,100.29-45.9,308.52-103.47,615.85,136.8,666.2,459.87,21.1-8.12,41.98-17.62,62.53-28.58,20.52-10.94,32.18-34.43,28.77-58.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1481.83,891.13c-47.17-326.39-356.71-570.6-667.33-466.42-74.3,24.62-140.16,65.35-195.28,118.08.49,2.32,1.04,4.61,1.55,6.92,44.44-33.68,94.25-60.4,148.64-78.42,310.62-104.17,620.16,140.04,667.33,466.42.99,6.85.57,13.66-.83,20.19,5.74-2.81,11.46-5.72,17.15-8.75,20.52-10.94,32.18-34.43,28.77-58.02Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M814.94,1121.42c-21.82,0-42.35-8.79-57.8-24.76-7.04-7.28-7.04-19.08,0-26.35,7.05-7.28,18.46-7.28,25.51,0,8.64,8.93,20.1,13.84,32.29,13.84s23.66-4.91,32.29-13.84c7.05-7.28,18.46-7.28,25.51,0,7.05,7.27,7.05,19.07,0,26.35-15.45,15.97-35.98,24.76-57.81,24.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1121.94,1121.42c-21.83,0-42.36-8.79-57.81-24.76-7.04-7.28-7.04-19.08,0-26.35,7.05-7.28,18.46-7.28,25.51,0,8.63,8.93,20.1,13.84,32.29,13.84s23.65-4.91,32.29-13.84c7.04-7.28,18.46-7.28,25.51,0,7.04,7.27,7.04,19.07,0,26.35-15.45,15.97-35.98,24.76-57.8,24.76Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M884.17,1417.65c-13.36,0-23.47-12.88-20.38-26.31,11.48-49.9,54.9-87.01,106.71-87.01,51.81,0,95.23,37.11,106.71,87.01,3.09,13.42-7.03,26.31-20.38,26.31h-172.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeMinorDiscomfort);
export default __webpack_public_path__ + "static/media/WE - Minor Discomfort.85d7cb31f7c083bd3d99ecefe9e0c416.svg";
export { ForwardRef as ReactComponent };